import {ref, computed} from "vue"
import {defineStore, acceptHMRUpdate} from "pinia"
import {firestore} from "@/firebase/index.js"
import {collection, deleteDoc, doc} from "firebase/firestore"
import {useShopStore} from "./shop"

export const useFilesShopImagesStore = defineStore("filesShopImages", () => {
  // stores
  const shopStore = useShopStore()

  // state
  const images = ref([])
  const status = ref("init")
  const unsubscribe = ref(null)

  // getters
  const filesShopImagesLoaded = computed(() => status.value == "loaded")

  // actions
  async function bind() {
    const shopId = shopStore.shopId
    const collectionRef = collection(firestore, `shops/${shopId}/images`)
    return await this.attach("images", collectionRef, serializeFiles)
  }

  async function unbind() {
    return await this.detach()
  }

  async function remove(args) {
    const imageId = args.id
    const shopId = shopStore.shopId
    const docRef = doc(firestore, `shops/${shopId}/images/${imageId}`)
    await deleteDoc(docRef)
    // TODO: remove file from storage
  }

  return {
    // state
    images,
    status,
    unsubscribe,

    // getters
    filesShopImagesLoaded,

    // actions
    bind,
    unbind,
    remove,
  }
})

// extend with properties
const serializeFiles = (snapshot, data) => {
  return Object.defineProperties(data, {
    id: {
      value: snapshot.id,
      writable: false,
      enumerable: false,
    },
    _module: {
      value: "filebrowser",
      writable: false,
      enumerable: false,
    },
  })
}

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFilesShopImagesStore, import.meta.hot))
}
